<template>
  <div class="kye-report-echarts-bar-001">
    <div class="kye-report-echarts-bar-001_dom" ref="zzt001"></div>
    <LegendSelected
      v-if="showLegendMoreComponent"
      ref="LegendSelected"
      :legendMoreMap="legendMoreMap"
      :echartsInstance="echartsInstance"
    ></LegendSelected>
  </div>
</template>

<script>
  import * as echarts from '@kyfe/echarts5'
  import { commonProps, extend } from '../common'
  import { CHARTS_CONFIG } from '../common/basic/basic-config.js'
  import { tooltipFormatterWrap, setLegendMoreMap } from '../common/utils.js'
  import { mergeObjects } from '../../utils/merge'
  import LegendSelected from '../components/legend-selected.vue'

  export default {
    components: {
      LegendSelected
    },
    props: extend({}, commonProps, {
      option: Object
    }),
    data() {
      return {
        echartsInstance: null,
        echartsConfig: {},
        code: '',
        legendMoreMap: {},
      }
    },
    computed: {
      showLegendMoreComponent () {
        const { visibleNum = 5, visibleNames = [] } = this.legendMoreMap || {}
        const leng = visibleNames.length ? visibleNames.length : visibleNum
        return this.showLegendMoreConfig && this.option.series.length > leng
      }
    },
    watch: {
      option: {
        deep: true,
        handler() {
          this.initEcharts()
        }
      }
    },
    mounted() {
      const { autoRender } = this.$props
      if (autoRender) {
        this.init()
      }
    },
    methods: {
      init() {
        this.initEcharts()
      },
      initEcharts() {
        const echartsInstance = echarts.init(this.$refs.zzt001)
        if (echartsInstance) {
          this.echartsInstance = echartsInstance
          const option = this.initEchartsConfig()
          this.echartsInstance.setOption(option, true)
          // 实例丢出去。自己监听自己想要的数据
          this.$emit('echartsInstanceCreated', echartsInstance)
        }
      },
      initEchartsConfig() {
        const {
          series = [],
          xAxis = [],
          yAxis = [],
          color = CHARTS_CONFIG.color,
          dataZoom,
          legend
        } = this.$props.option || {}
        const option = {
          tooltip: {
            ...CHARTS_CONFIG.tooltip,
            ...CHARTS_CONFIG.tooltipAxisPointer.shadow,
            formatter: (val) => {
              const tooltipFormatterConfig = this.$props.tooltipFormatterConfig || {}
              return tooltipFormatterWrap(val, tooltipFormatterConfig, legend)
            },
          },
          legend: {
            ...CHARTS_CONFIG.legend,
            icon: 'circle'
          },
          grid: {
            ...CHARTS_CONFIG.grid,
          },
          xAxis: Array.from({length: xAxis.length || 1}).map(_ => {
            return {
              type: 'category',
              ...CHARTS_CONFIG.xAxis,
            }
          }),
          yAxis: Array.from({length: yAxis.length || 1}).map((ele, index) => {
            const right = index === 0
            const align = {
              ...(right ? {
                ...CHARTS_CONFIG.yAxis,
                ...CHARTS_CONFIG.yAxisAlignRight
                } : {
                  ...CHARTS_CONFIG.yAxis,
                  ...CHARTS_CONFIG.yAxisAlignLeft,
                })
            }
            return {
              type: 'value',
              ...CHARTS_CONFIG.yAxis,
              ...align,
            }
          }),
          color,
          series: Array.from({length: series.length}).map((ele, index) => {
            return {
              ...CHARTS_CONFIG.seriesBarOpt,
            }
          }),
          dataZoom: dataZoom ? {
            ...CHARTS_CONFIG.dataZoom
          } : null
        }
        const mergedOption = mergeObjects({...option}, {...this.$props.option})
        if (this.showLegendMoreConfig) {
          const { legendMoreMap } = setLegendMoreMap(series, mergedOption, this.$props.legendMoreMapConfig)
          this.legendMoreMap = legendMoreMap
        }
        return mergedOption
      }
    },
  }
</script>
<style lang="less" scoped>
  @width100: 100%;
  .kye-report-echarts-bar-001 {
    position: relative;
    width: @width100;
    height: @width100;
    box-sizing: border-box;
    &_dom{
      width: @width100;
      height: @width100;
    }
  }
</style>



// WEBPACK FOOTER //
// src/public/components/kye-report-form/echarts/bar/index.vue